export default {
  inject: ['load'],
  data() {
    return {
      allRoles: [],
    };
  },
  methods: {
    getAllRoles: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllRoles').then(() => {
        if (this.$store.state.roleModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.allRoles = this.$store.state.roleModule.allRoles;
          if (this.$route.name == 'addUser') {
            this.defineRoles(this.allRoles);
          } else if (this.$route.name == 'user') {
            if (this.searchModal == false) {
              this.allUserRoles = this.allRoles;
              this.readyUserRole();
            }
          } else if (this.$route.name == 'userGroup') {
            this.allUserGroupRoles = this.allRoles;
            this.readyUserGroupRole();
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.roleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.roleModule.successFlag) {
                this.getAllRoles();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.roleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllRoles();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.roleModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
